import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ReviewDisplayComponent } from '../review-display/review-display.component';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'detailed-review-display',
    templateUrl: './detailed-review-display.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ReviewDisplayComponent, DatePipe]
})
export class DetailedReviewDisplayComponent extends ReviewDisplayComponent {


}
